/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowotherlettering3Inputs */

const en_aiflowotherlettering3 = /** @type {(inputs: Aiflowotherlettering3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Different lettering`)
};

const de_aiflowotherlettering3 = /** @type {(inputs: Aiflowotherlettering3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Schrift`)
};

/**
* | output |
* | --- |
* | "Different lettering" |
*
* @param {Aiflowotherlettering3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowotherlettering3 = /** @type {((inputs?: Aiflowotherlettering3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowotherlettering3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowotherlettering3(inputs)
	return de_aiflowotherlettering3(inputs)
});
export { aiflowotherlettering3 as "aiFlowOtherLettering" }